import DataGrid from "devextreme/ui/data_grid";
import Vue from "vue";

export default {
  initialise() {
    DataGrid.defaultOptions({
      device: true,
      options: {
        // Here go the DataGrid options
        pager: { showPageSizeSelector: true, showInfo: true, visible: true },
        paging: { pageSize: 50 },
        filterRow: { visible: false },

        elementAttr: { class: "dx-card wide-card" },
        columnMinWidth: 50,
        allowColumnReordering: true,
        showBorders: false,
        focusedRowEnabled: false,
        columnAutoWidth: true,
        columnHidingEnabled: false,
        selection: { mode: "single" },
        hoverStateEnabled: true,
        columnFixingEnabled: true,
        wordWrapEnabled: true,
        twoWayBindingEnabled: true,
        searchPanel: {
          visible: true,
          highlightCaseSensitive: true,
          highlightSearchText: false,
        },
        columnChooser: {
          enabled: true,
          allowSearch: true,
          mode: "select",
          height: "100%",
          width: 300,
        },
        noDataText: "",

        // eslint-disable-next-line no-unused-vars
        onOptionChanged: function(e) {
          if (e.fullName == "searchPanel.text") {
            if (e.value != "") {
              Vue.prototype.$logger.trackEventGridSearch({
                value: e.value,
              });
            }
          }
        },
      },
    });
  },
};
